import { create } from "zustand";

import axios from "../helper/axios";

const useResumeDataBaseStore = create((set,get) => ({
    resumeDataBaseDetails: [],
    resumeDataBaseTotalCount:0,
    resumeDataBaseUpdateFlag: false,
 
    getResumesFromDatabase: async (data) => {
        try {
           const userData = JSON.parse(localStorage.getItem("userDetails"));
           console.log(data);
           const response = await axios.post(`/getResumesFromDatabase/${userData.account_type}/${userData.qhoid}/${userData.qhuid}`,data);
           console.log(response.data.name); 
           console.log(response.data.data);
           console.log(response.data.totalCount);
           set({ resumeDataBaseDetails: response?.data.data });
           set({ resumeDataBaseTotalCount: response?.data.totalCount });
        } catch (err) {
            console.error(err);
        }
    },
    resumeDataBaseUpgradeResumes: async (body) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/resumeDataBaseUpgradeResumes/${userData.qhoid}/${userData.qhuid}`,
                body.jasonValues
            );
            console.log(response.data.name); 
            console.log(response.data.status);
            set({ resumeDataBaseUpdateFlag: true });
        } catch (err) {
            console.error(err);
        }
    }, 
    resetResumeDataBaseUpdateFlag: async () => {
        set({ resumeDataBaseUpdateFlag: false });
    },         

}));

export default useResumeDataBaseStore;
